/** Keys for the physician portal's screen-data cache (see useCachedQuery). */
export const physicianQueryKeys = {
  queue: "physician:queue",
  mine: "physician:mine",
  reviewItem: (id: string) => `physician:review-item:${id}`,
};
